export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

/**
 * Derive the public-facing origin from an incoming request.
 * Uses proxy headers so the URL always matches what the client connected to,
 * avoiding mismatches between Vercel branch URLs and deployment URLs.
 *
 * This is important for handling Vercel preview deployments, where the deployment URL (e.g. `https://abc123.vercel.app`)
 * may differ from the URL the client used to connect (e.g. `https://my-feature-branch.myapp.com`).
 *
 * If we don't forward the correct origin, we'll get a Client origin mismatch and the client will be rejected.
 */
export const getRequestOrigin = (req: Request): string => {
  const proto = req.headers.get("x-forwarded-proto") ?? "https";
  const host = req.headers.get("host") ?? new URL(req.url).host;
  return `${proto}://${host}`;
};
